import { Link, useNavigate } from 'react-router-dom';
import api from "../services/api";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Card, CardContent, Typography, Button, Snackbar, Alert, Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Save as IconSave } from "@mui/icons-material";
import { PaperComponentDraggable } from "./PaperComponentDraggable";
import PersonaNatural from './PersonaNatural'
import PersonDirection from './PersonDirection'
import PersonDocument from './PersonDocument'
import PersonContact from './PersonContact'
import PersonBonding from './PersonBonding'
import PersonPast from './PersonPast'
import { activeValidationsPersonaNatural, setNombreVinculado, setTipoPersona, initPerson } from "../redux/personSlice";
import { activeValidationsPersonaDocumento } from "../redux/personDocumentSlice";
import { setPersonaDirecciones } from '../redux/personDirectionSlice';
import { setPersonaVinculaciones } from '../redux/personBondingSlice';
import { setPersonaContactos } from '../redux/personContactSlice';
import { setPersonaDocumentos } from '../redux/personDocumentSlice';
import { setPersonaAntecedentes } from '../redux/personPastSlice';
import * as personaService from "../services/personaService";
import * as catalogoService from "../services/catalogoService";
import { notifySuccess, notifyWarning, notifyError } from "../services/notificationService";

const PersonRegister = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dialogRef = useRef();
    const sliceKey = props.sliceKey;
    const initialized = useRef(false);

    useEffect(() => {
        if (props.open && !initialized.current) {
            dispatch(initPerson({ sliceKey: sliceKey }));
            setEnabledSave(true);
            initialized.current = true;
        }
        if (!props.open) {
            initialized.current = false;
        }
    }, [props.open, dispatch, sliceKey]);

  const personaNatural = useSelector((state) => state.person[sliceKey]?.personaNatural);
  const personaDirecciones = useSelector((state) => state.personDirection[sliceKey]?.personaDirecciones);
  const personaDocumentos = useSelector((state) => state.personDocument[sliceKey]?.personaDocumentos);
  const personaContactos = useSelector((state) => state.personContact[sliceKey]?.personaContactos);
  const personaVinculaciones = useSelector((state) => state.personBonding[sliceKey]?.personaVinculaciones);
  const personaAntecedentes = useSelector((state) => state.personPast[sliceKey]?.personaAntecedentes);
  const personaNaturalValidation = useSelector((state) => state.person[sliceKey]?.validationMessage);
  const personaDocumentosValidation = useSelector((state) => state.personDocument[sliceKey]?.validationMessage);
  const tipoPersona = useSelector((state) => state.person[sliceKey]?.tipoPersona);

  const defaultPersonaDirecciones = useSelector((state) => state.personDirection[sliceKey]?.defaultPersonaDirecciones);
  const defaultPersonaDocumentos = useSelector((state) => state.personDocument[sliceKey]?.defaultPersonaDocumentos)
  const defaultPersonaContactos = useSelector((state) => state.personContact[sliceKey]?.defaultPersonaContactos);
  const defaultPersonaVinculaciones = useSelector((state) => state.personBonding[sliceKey]?.defaultPersonaVinculaciones);
  const defaultPersonaAntecedentes = useSelector((state) => state.personPast[sliceKey]?.defaultPersonaAntecedentes);

//   const [openMessage, setOpenMessage] = useState(false)
//   const onCloseMessage = () => { setOpenMessage(!openMessage); }
//   const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const [enabledSave, setEnabledSave] = useState(true)
  const [idNew, setIdNew] = useState(0)
  const [nameNew, setNameNew] = useState("")

  const personaPost = async () => {
    var dataPost = {
        ...personaNatural, nombres: personaNatural.primerApellido + " " + personaNatural.segundoApellido + " " + personaNatural.primerNombre + " " + personaNatural.segundoNombre
        , idSexo: parseInt(personaNatural.idSexo)
        , personaDireccion: personaDirecciones, personaDocumento: personaDocumentos, personaContacto: personaContactos, personaVinculacion: personaVinculaciones
        , personaAntecedente: personaAntecedentes
    }

    var ValidationMessages = personaNaturalValidation.concat(personaDocumentosValidation)

    if (ValidationMessages.length > 0) {
        dispatch(activeValidationsPersonaNatural({sliceKey: sliceKey}));
        dispatch(activeValidationsPersonaDocumento({sliceKey: sliceKey}));

        notifyWarning(ValidationMessages.join(" - "))
        // setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
        // setOpenMessage(true);
    }
    else {
      try {
        const response = await personaService.postPersonaNaturalUpdateWithDetails(dataPost)

        notifySuccess("Se guardaron los datos con éxito");
        setIdNew(parseInt(response.data.data))
        setNameNew(personaNatural.primerApellido + " " + personaNatural.segundoApellido + " " + personaNatural.primerNombre + " " + personaNatural.segundoNombre)
        setEnabledSave(false);

        if (personaNatural.id > 0) {
          const directions = await personaService.getsPersonaDireccionView(personaNatural.id)
        //   const bondings = await personaService.getsPersonaVinculacionView(personaNatural.id)
          const contacts = await personaService.getsPersonaContactoView(personaNatural.id)
          const documents = await personaService.getsPersonaDocumentoView(personaNatural.id)
          const pasts = await personaService.getsPersonaAntecedenteView(personaNatural.id)
          
          dispatch(setPersonaDirecciones({sliceKey: sliceKey, data: directions?.length ? directions : defaultPersonaDirecciones}));
        //   dispatch(setPersonaVinculaciones({sliceKey: sliceKey, data: bondings?.length ? bondings : defaultPersonaVinculaciones}));
          dispatch(setPersonaContactos({sliceKey: sliceKey, data: contacts?.length ? contacts : defaultPersonaContactos}));
          dispatch(setPersonaDocumentos({sliceKey: sliceKey, data: documents?.length ? documents : defaultPersonaDocumentos}));
          dispatch(setPersonaAntecedentes({sliceKey: sliceKey, data: pasts?.length ? pasts : defaultPersonaAntecedentes}));
        }
      } catch (error) {
        notifyError(error.response?.data?.message ?? error.message ?? "An unexpected error occurred.");
      }
        
        // await api.post("/Persona/PostPersonaNaturalUpdateWithDetails", dataPost)
        //     .then(response => {
        //     setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
        //     setOpenMessage(true);
        //     setIdNew(parseInt(response.data.data))
        //     setNameNew(personaNatural.primerApellido + " " + personaNatural.segundoApellido + " " + personaNatural.primerNombre + " " + personaNatural.segundoNombre)
        //     setEnabledSave(false);

        //     if (personaNatural.id > 0){
        //         api.get("/Persona/GetPersonasDireccionesViewByIdPersona?idPersona=" + personaNatural.id)
        //         .then(directions => {
        //             if (directions.data.data === null || directions.data.data.length === 0)
        //                 dispatch(setPersonaDirecciones(defaultPersonaDirecciones));
        //             else
        //                 dispatch(setPersonaDirecciones(directions.data.data));
        //         })
        //         .catch((err) => {
        //         console.log("Err: ", err);
        //         });

        //         api.get("/Persona/GetPersonasVinculacionesViewByIdPersona?idPersona=" + personaNatural.id)
        //         .then(bondings => {
        //             if (bondings.data.data === null || bondings.data.data.length === 0)
        //                 dispatch(setPersonaVinculaciones(defaultPersonaVinculaciones));
        //             else
        //                 dispatch(setPersonaVinculaciones(bondings.data.data));
        //         })
        //         .catch((err) => {
        //         console.log("Err: ", err);
        //         });

        //         api.get("/Persona/GetPersonasContactosViewByIdPersona?idPersona=" + personaNatural.id)
        //         .then(contacts => {
        //             if (contacts.data.data === null || contacts.data.data.length === 0)
        //                 dispatch(setPersonaContactos(defaultPersonaContactos));
        //             else
        //                 dispatch(setPersonaContactos(contacts.data.data));
        //         })
        //         .catch((err) => {
        //         console.log("Err: ", err);
        //         });
                
        //         api.get("/Persona/GetPersonasDocumentosViewByIdPersona?idPersona=" + personaNatural.id)
        //         .then(documents => {
        //         if (documents.data.data === null || documents.data.data.length === 0)
        //             dispatch(setPersonaDocumentos(defaultPersonaDocumentos));
        //         else
        //             dispatch(setPersonaDocumentos(documents.data.data));
        //         })
        //         .catch((err) => {
        //         console.log("Err: ", err);
        //         });
            
        //         api.get("/Persona/GetPersonasAntecedentesViewByIdPersona?idPersona=" + personaNatural.id)
        //         .then(pasts => {
        //         if (pasts.data.data === null || pasts.data.data.length === 0)
        //             dispatch(setPersonaAntecedentes(defaultPersonaAntecedentes));
        //         else
        //             dispatch(setPersonaAntecedentes(pasts.data.data));
        //         })
        //         .catch((err) => {
        //         console.log("Err: ", err);
        //         });
        //     }
        // })
        // .catch(error => {
        // setPropsMessage({ severity: "error", message: "Hubo un error" })
        // setOpenMessage(true);
        // });
    }
  }
    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"md"}
            ref={dialogRef}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle
                id="draggable-dialog-title"
                style={{ cursor: "move" }}>
                <Typography variant="h5" component="span">
                    <Box sx={{ fontWeight: 'bold' }}>
                        {(props.id > 0 ? "Editar" : "Registrar") + " Persona"}
                    </Box>
                </Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "350px", maxHeight: "400px" }}>
                <div>
                    {/* <Grid container spacing={0}>
                        <Grid item xs={8} sm={8}>
                            <Typography variant="h5" component="span">
                                <Box sx={{ fontWeight: 'bold' }}>
                                {(params.id == 0 ? (params.idTipoPersona > 0 ? "Registrar " + tipoPersona : "Nueva Persona") : "Editar Persona")}
                                </Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4}>
                            <Box textAlign='right'>
                                <Link to={'/person'} >{"Volver"}</Link>
                            </Box>
                        </Grid>
                    </Grid> */}

                    {/* <Grid container spacing={0}>
                        <Grid item xs={12} sm={12}>
                        <Box textAlign='center'>
                            <Link reloadDocument to={ "/person/edit/0/" + (idNew) + "/" + (parseInt(params.idTipoPersona) == 23 ? 93 : 0) } style={{ display: continueDisplay }} >{"Continuar Registro >>"}</Link>
                        </Box>
                        </Grid>
                    </Grid> */}

                    <Typography gutterBottom component="span">
                        <Box textAlign='center' padding={1}>
                        <Button variant="outlined" size='small' onClick={() => {personaPost()}} disabled={!enabledSave} >
                            Guardar
                            <IconSave />
                        </Button>
                        </Box>
                    </Typography>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                        <Card >
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                            <PersonaNatural sliceKey={sliceKey} hideInputs={props.hideInputs} id={props.id} autoFocus />
                            </CardContent>
                        </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                            <PersonDocument sliceKey={sliceKey} id={props.id} />
                            </CardContent>
                        </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                            <PersonContact sliceKey={sliceKey} id={props.id} />
                            </CardContent>
                        </Card>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                            <PersonDirection sliceKey={sliceKey} id={props.id} />
                            </CardContent>
                        </Card>
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                            <PersonBonding id={0} />
                            </CardContent>
                        </Card>
                        </Grid> */}
                        <Grid item xs={12} sm={4}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                            <PersonPast sliceKey={sliceKey} id={props.id} />
                            </CardContent>
                        </Card>
                        </Grid>
                    </Grid>
                    {/* <Grid container spacing={0}>
                        <Grid item xs={12} sm={12}>
                        <Box textAlign='center'>
                            <Link reloadDocument to={ "/person/edit/0/" + (idNew) + "/" + (parseInt(params.idTipoPersona) == 24 ? 23 : 93) } style={{ display: continueDisplay }} >{"Continuar Registro >>"}</Link>
                        </Box>
                        </Grid>
                    </Grid> */}
                    <Typography component="span">
                        <Box textAlign='center' padding={1}>
                        <Button variant="outlined" size='small' onClick={() => {personaPost()}} disabled={!enabledSave}>
                            Guardar
                            <IconSave />
                        </Button>
                        </Box>
                    </Typography>
                    {/* <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                        anchorOrigin={{vertical: "top", horizontal: "center"}}>
                        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                        {propsMessage.message}
                        </Alert>
                    </Snackbar> */}
                </div>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={() => {
                    if (idNew > 0) {
                        // const selectItems = results.filter(item => item.id === selectItem[0]);
                        props.setNewPersonSaved(idNew, nameNew);
                        props.openClose()
                    }
                }}>Aceptar</Button>
                <Button onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default PersonRegister;
